import { Loader2 } from 'lucide-react';

const LoadingModal = ({ loading, isGeneratingPdf }) => {
  if (!loading) return;

  return (
    <div className={`fixed inset-0 flex items-center justify-center z-50 ${isGeneratingPdf ? 'backdrop-blur-lg' : 'bg-black bg-opacity-50'}`}>
      <div className="bg-white p-6 rounded-lg flex flex-col items-center gap-4 shadow-lg">
        <Loader2 className={`w-8 h-8 animate-spin ${isGeneratingPdf ? 'text-red-600' : 'text-red-600'}`} />
        <p className="text-gray-800 font-medium">
          {isGeneratingPdf ? 'Generating PDF ... please wait' : 'Loading, please wait...'}
        </p>
      </div>
    </div>
  );
};

const LoadingSpinner = ({ fullPage = false }) => {
  return (
    <div className={`flex items-center justify-center ${fullPage ? 'h-screen' : 'h-full'}`}>
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
    </div>
  );
};

export { LoadingSpinner, LoadingModal };